import { convertDate } from '../../helpers/dateFormat';
// import styles from '../../../styles/page.scss'

const
    quotationStatus =
    {
        1: "New",
        2: "Replied",
        3: "Request Visual",
        4: "Visual Received",
        5: "Cancelled",
        6: "Approved"
    }

export const QuoteKanabanColum = [
    { key: 1, title: 'New' },
    { key: 2, title: 'Replied' },
    { key: 3, title: 'Request Visual' },
    { key: 4, title: 'Visual Received' },
    { key: 5, title: 'Cancelled' },
    { key: 6, title: 'Approved' },

]


export const QuoteColumn = [
    {
        title: 'Project Id',
        dataIndex: 'project_item',
        render: (project_item) => project_item.global_project_id
    },
    {
        title: 'Received Date',
        dataIndex: 'createdAt',
        render: (createdAt) => {
            return convertDate(String(createdAt))
        }
    },
    {
        title: 'Deadline Delivery Date',
        dataIndex: 'expected_delivery_date',
        render: (expected_delivery_date) => {
            return expected_delivery_date != null ? convertDate(String(expected_delivery_date)) : ""
        }
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: status => quotationStatus[status],

    }

]